import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";

export const getTags = createAsyncThunk(
  "tags/get",
  async (_, { rejectWithValue }) => {
    return api
      .get("tags/")
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return rejectWithValue(err.response?.data);
      });
  },
  {
    condition: (params, { getState }) => {
      if (params?.ignoreCondition) {
        return true;
      }
      // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
      const { status } = selectTags(getState());
      if (status === "fulfilled" || status === "pending") {
        // Already fetched or in progress, don't need to re-fetch
        return false;
      }
    },
  }
);

const initialState = {
  status: "idle",
  data: [],
  error: null,
};

const tagsSlice = createSlice({
  name: "tags",
  initialState,
  reducers: {
    add: (state, action) => {
      state.data.push(action.payload);
    },
    set: (state, action) => {
      state.data = state.data.map((d) =>
        d.id === action.payload.id ? action.payload : d
      );
    },
    delete: (state, action) => {
      state.data = state.data.filter((d) => d.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTags.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getTags.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload;
      })
      .addCase(getTags.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase("auth/logout", () => initialState);
  },
});

export const tagsActions = tagsSlice.actions;

const _selectTags = (state) => state.tags;

export const selectTags = createSelector(
  [(state) => _selectTags(state)],
  (tags) => {
    const data = tags.data;
    const status = tags.status;
    const error = tags.error;
    const isLoading = status === "pending";
    return { data, status, error, isLoading };
  }
);

export default tagsSlice.reducer;
